<template>
    <div class="table__wrapper">
        <table class="kitchen-tickets__table">
            <tr
                v-for="(row, index) in processedTickets"
                :key="index"
                :style="{ height: rowHeight }"
            >
                <td
                    v-for="ticket in row"
                    :key="ticket?.id"
                    :style="{ height: rowHeight }"
                >
                    <kitchen-display-card
                        v-if="!!ticket"
                        :ticket="ticket"
                        :disabled="disabled"
                    />
                </td>
            </tr>
        </table>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import Terminal from '@/models/Terminal';
import useRouter from '@/utilities/useRouter';
import useKitchenTickets from './useKitchenTickets';
import KitchenDisplayCard from './KitchenDisplayCard.vue';

const { route } = useRouter();
const { openTickets, doneTickets, openPage, donePage, gridRows, gridCols } = useKitchenTickets();

const isDonePage = computed(() => route.value.name === 'kitchenDoneTickets');

const page = computed(() => (route.value.name === 'kitchenDoneTickets' ? donePage.value : openPage.value));

const filteredTickets = computed(() => {
    let paginatedTickets = openTickets.value.filter((ticket) => ticket.page === page.value);

    if (isDonePage.value) {
        paginatedTickets = doneTickets.value.filter((ticket) => ticket.page === page.value);
    }

    return paginatedTickets;
});

const processedTickets = computed(() => {
    const tickets = [];

    for (let i = 0; i < gridRows.value; i++) {
        const row = [];

        for (let j = 0; j < gridCols.value; j++) {
            row.push(filteredTickets.value[i * gridCols.value + j]);
        }

        tickets.push(row);
    }

    return tickets;
});

const rowHeight = computed(() => {
    return 100 / gridRows.value + '%';
});

const disabled = ref(false)

onMounted(async () => {
    const terminal = await Terminal.current();
    const isKDSTerminal = terminal?.isKitchenDisplaySystem();
    disabled.value = !isKDSTerminal
})
</script>

<style lang="scss" scoped>
.table__wrapper {
    height: 100%;
    overflow: hidden;
}

.kitchen-tickets__table {
    width: 100%;
    height: 100%;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 8px;
}

.order__transition {
    display: contents;
    margin: -4px;
}

.table-enter-active {
    transition: all 500ms;
}

.table-enter,
.table-leave-to {
    opacity: 0;
    transform: translateY(30px);
}
</style>
